import { FunctionComponent, HTMLAttributes } from 'react';
import styled from 'styled-components';

interface FooterProps extends HTMLAttributes<HTMLDivElement> {}
interface SocialLinkProps extends HTMLAttributes<HTMLLIElement> {
  aHref: string;
  social: 'bluesky' | 'instagram' | 'spotify';
}

const SocialLink: FunctionComponent<SocialLinkProps> = ({ aHref, social }) => (
  <li>
    <a href={aHref} rel="noopener noreferrer" target="_blank">
      <img src={`${process.env.PUBLIC_URL}/${social}.svg`} alt={social} />
      <span className="sr-only">opens in a new tab</span>
    </a>
  </li>
);

const UnstyledFooter: FunctionComponent<FooterProps> = (props) => {
  return (
    <footer {...props} id="Footer">
      <ul className="no-list-styling">
        <SocialLink aHref="https://open.spotify.com/show/48Y1fGZIiR6V6BR6MGx8d4" social="spotify" />
        <SocialLink aHref="https://bsky.app/profile/eati.games" social="bluesky" />
      </ul>
      <span className="copyright"><span className="copy-symbol">&copy;</span><a href="https://emmi.dev">Emmi Russo</a>, 2025</span>
    </footer>
  );
};

const StyledFooter = styled(UnstyledFooter)`
  align-items: center;
  background-color: #49A078;
  display: flex;
  flex-direction: column;
  gap: 6px;
  justify-content: center;
  min-height: max(15vh, 15%);

  .copyright {
    align-items: center;
    display: flex;
  }

  .copy-symbol {
    margin-right: 6px;
  }

  img {
    height: 30px;
    width: 30px;
  }

  ul {
    display: flex;
    flex-direction: row;
    gap: 12px;
  }


  @media screen and (max-width: 800px) {
    ul {
      margin: 0;
    }
  }

  @media screen and (min-width: 800px) {
    gap: 0;
    padding: 10px 0 15px;

    img {
      height: 60px;
      width: 60px;
    }
  }
`;

export const Footer: FunctionComponent<FooterProps> = (props) => (
  <StyledFooter {...props} />
);